import { render, staticRenderFns } from "./FreeholdWithManagementCoYN.vue?vue&type=template&id=5245b3b0"
import script from "./FreeholdWithManagementCoYN.vue?vue&type=script&lang=js"
export * from "./FreeholdWithManagementCoYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports